import fetch from "auth/FetchInterceptor";

const OrderService = {};

OrderService.getOrders = function (page = 1, filters = {}) {
  // Build query parameters
  const params = new URLSearchParams();
  params.append("page", page);

  // Add date filter
  if (filters.dateFilter) {
    params.append("date_filter", filters.dateFilter);
  }

  // Add custom date range
  if (filters.startDate) {
    params.append("start_date", filters.startDate);
  }
  if (filters.endDate) {
    params.append("end_date", filters.endDate);
  }

  // Add order status filter
  if (filters.orderStatus) {
    params.append("order_status_id", filters.orderStatus);
  }

  // Add payment status filter
  if (filters.paymentStatus) {
    params.append("payment_status", filters.paymentStatus);
  }

  return fetch({
    url: `/orders/?${params.toString()}`,
    method: "get",
  });
};

OrderService.getOrder = function (id) {
  return fetch({
    url: `/orders/${id}`,
    method: "get",
  });
};

OrderService.updateOrders = function (data) {
  return fetch({
    url: `/orders/${data.id}/`,
    method: "put",
    data: { order_status_id: data.order_status_id },
  });
};

OrderService.deleteOrders = function ({ id }) {
  return fetch({
    url: `/orders/${id}/`,
    method: "delete",
  });
};

export default OrderService;
